import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://offerta.katenic.com',
  headers: { 'Content-Type': 'application/json' }
});



const app = createApp(App);
app.config.globalProperties.$apiClient = apiClient;
app.use(router);
app.mount('#app');
